module.exports = require("@babel/runtime/core-js/array/from");